/*
 * types/services/collection.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {CollectionResponseResponseState} from './CollectionResponseResponseState';

/**
 * The CollectionDeleteCollectionResponse model module.
 * @module model/CollectionDeleteCollectionResponse
 * @version version not set
 */
export class CollectionDeleteCollectionResponse {
  /**
   * Constructs a new <code>CollectionDeleteCollectionResponse</code>.
   * @alias module:model/CollectionDeleteCollectionResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>CollectionDeleteCollectionResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CollectionDeleteCollectionResponse} obj Optional instance to populate.
   * @return {module:model/CollectionDeleteCollectionResponse} The populated <code>CollectionDeleteCollectionResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CollectionDeleteCollectionResponse();
      if (data.hasOwnProperty('state'))
        obj.state = CollectionResponseResponseState.constructFromObject(data['state']);
    }
    return obj;
  }
}

/**
 * @member {module:model/CollectionResponseResponseState} state
 */
CollectionDeleteCollectionResponse.prototype.state = undefined;


